import { Component, isDevMode, OnDestroy, OnInit } from '@angular/core';
import {environment} from "../../../../environments/environment";
import {ChildService} from "../../../components/child/child.service";
import {CentreService} from "../../../services/centre.service";
import {MatTableDataSource} from "@angular/material/table";
import {Centre} from "../../../interfaces/Centres";
import {WeeklyReport} from "../ops-reports/weekly-reports/weekly-reports.component";
import {FullChild} from "../../../interfaces/FullChild";
import {Subject, takeUntil} from "rxjs";
import {map} from "rxjs/operators";
import {AdmissionType} from "../../../interfaces/AdmissionType";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import firebase from "firebase/compat/app";
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-centre-ranking',
  templateUrl: './centre-ranking.component.html',
  styleUrls: ['./centre-ranking.component.scss']
})
export class CentreRankingComponent implements OnInit, OnDestroy {
  env = isDevMode() ? environment.testMode : environment.productionMode;
  startDate1!: Date
  endDate1!: Date
  admittedList: string[] = []

  dataSource!: MatTableDataSource<WeeklyReport>;
  displayedColumns: String[] = ['centername', 'totalunits', 'occupiedunits',  'percentage','weekId'];
  allCentres: Centre[] = [];
  mCentres: Centre[] = [];
  mWeekly: WeeklyReport[] = [];
  pCOUNT = 0
  pCOUNT2 = 0
  pList: string[] = []
  pList2: string[] = []
  totalUnits = 0
  totalOccupiedUnits = 0
  totalAvailableUnits = 0
  mAllChild: FullChild[] = []
  mSortedChild: FullChild[] = []
  _destroyed$ = new Subject<void>()
  showLog = false

  constructor(
      private readonly mChildService: ChildService,
      private  readonly mFirestore:AngularFirestore,
      private readonly mCenterService: CentreService,
      private readonly mDatePipe:DatePipe
  ) { }


  ngOnInit(): void {
    if (this.mAllChild.length == 0) this.mChildService.getLatestData().pipe(takeUntil(this._destroyed$),
        map(x => x.docs.map(y => y.data())
        )
    ).subscribe(res => {
      this.mAllChild = res
      this.mSortedChild = this.mAllChild

    })
    this.initAllCentresData('All')
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }


  private initAllCentresData(centreCode: string) {
    console.log('getAllCentre Called with:', centreCode);

    if (centreCode === 'All') {
      // At startup when centreCode == "All"
      if (this.allCentres.length === 0) {
        this.mCenterService.getAllCentres().pipe(takeUntil(this._destroyed$)).subscribe(centres => {
          this.allCentres = centres;
          console.log('CENTRE LIST TABLE', centres);
          this.calculateTotalUnits();
          // Uncomment the following lines if needed
          // this.addExtraRowToOccupancyTable(this.totalUnits, this.totalAvailableUnits, this.totalOccupiedUnits, 'Total');
          // this.dataSource.paginator = this.paginator;
          // this.getTotalUnitsCount(this.allCentres);
        });
      }
      console.log('allCentres if', this.allCentres.length);
    } else if (centreCode !== 'All') {
      console.log('Into getAllCentresData with centreCode ==', centreCode);
      this.mCentres = this.allCentres.filter(c => c.centreCode === centreCode);
      console.log('CENTRE LIST TABLE', this.mCentres);

      this.calculateTotalUnits();
      // Uncomment the following lines if needed
      // this.addExtraRowToOccupancyTable(this.totalUnits, this.totalAvailableUnits, this.totalOccupiedUnits, 'Total');
      this.dataSource = new MatTableDataSource(this.mWeekly);
      // this.dataSource.paginator = this.paginator;
      // this.getTotalUnitsCount(this.allCentres);

      // console.log('allCentres else', this.allCentres.length);
    }
  }

  private calculateTotalUnits() {
    this.totalUnits = 0;
    this.totalAvailableUnits = 0;
    this.totalOccupiedUnits = 0;

    this.allCentres.forEach(c => {
      this.totalUnits += +c.totalUnits!;
      this.totalAvailableUnits += +c.availableUnits!;
      this.totalOccupiedUnits += +c.occupiedUnits!;
    });
  }
  SearchData() {
    this.mWeekly = []
    this.calculateByCentre('AL Ahmedabad', 'ALAhmedabad', this.startDate1, this.endDate1)
    this.calculateByCentre('AL Bandra', 'ALBandra', this.startDate1, this.endDate1)
    this.calculateByCentre('AL Bangalore', 'ALBangalore', this.startDate1, this.endDate1)
    this.calculateByCentre('AL Chandigarh', 'ALChandigarh', this.startDate1, this.endDate1)
    this.calculateByCentre('AL Diamond Garden', 'ALDiamondGarden', this.startDate1, this.endDate1)
    this.calculateByCentre('AL Gurunanak Niwas', 'ALGurunanak', this.startDate1, this.endDate1)
    this.calculateByCentre('AL Manipal', 'ALManipal', this.startDate1, this.endDate1)
    this.calculateByCentre('AL Pune', 'ALPune', this.startDate1, this.endDate1)
    this.calculateByCentre('AL Sandu Garden', 'ALSanduGarden', this.startDate1, this.endDate1)
    this.dataSource = new MatTableDataSource(this.mWeekly);
  }

  calculateByCentre(centreName: string, centreCode: string, startDate: Date, endDate: Date) {
    this.pList = [];
    this.pList2 = [];

    const currentCenter = this.allCentres.find(x => x.centreCode === centreCode);
    if (!currentCenter) {
      console.log('Center not found:', centreCode);
      return;
    }

    const admission: FullChild[] = [];
    const discharge: FullChild[] = [];
    let firstAdmission = 0;
    let firstDischarge = 0;
    let admissionCount = 0;
    let dischargeCount = 0;
    this.pCOUNT = 0;
    this.pCOUNT2 = 0;
    const oscount = this.mAllChild.filter(child => {
      // Check if the status is 'OM SHANTI'
      const isOMSHANTI = child.status === 'OM SHANTI';

      // Check if the admission date falls within the specified range
      const admissionDate = child.admissionData[0]?.dateOfAdmission?.toDate();
      const isWithinRange = admissionDate && admissionDate >= this.startDate1 && admissionDate <= this.endDate1;

      // Check if the center code matches the current center being processed
      const isSameCentre = child.centreCode === centreCode;

      // Return true if all conditions are met
      return isOMSHANTI && isWithinRange && isSameCentre;
    }).length;



    const damacount = this.mAllChild.filter(child => {
      // Check if the status is 'OM SHANTI'
      const isOMSHANTI = child.status === 'DAMA';

      // Check if the admission date falls within the specified range
      const admissionDate = child.admissionData[0]?.dateOfAdmission?.toDate();
      const isWithinRange = admissionDate && admissionDate >= this.startDate1 && admissionDate <= this.endDate1;

      // Check if the center code matches the current center being processed
      const isSameCentre = child.centreCode === centreCode;

      // Return true if all conditions are met
      return isOMSHANTI && isWithinRange && isSameCentre;
    }).length;


    //const oscount = this.mAllChild.filter(child => child.centreCode === centreCode && child.status === 'OM SHANTI').length;
    //const damacount = this.mAllChild.filter(child => child.centreCode === centreCode && child.status === 'DAMA').length;
    // const totalPreviousAdmissions = this.mAllChild.filter(x => x.admissionData[0]?.dateOfAdmission?.toDate()! <= startDate);
    const totalPreviousAdmissions2 = this.mAllChild.filter(x => x.admissionData[0]?.dateOfAdmission?.toDate()! <= endDate);

    // console.log('TOTAL PREVIOUS ADMISSIONS', totalPreviousAdmissions.length);

    // totalPreviousAdmissions.forEach(child => {
    //   if (child.centreCode === centreCode) {
    //     child.admissionData.forEach((ad, i) => {
    //       this.checkPreviousAdmissionNew(i, ad, child.admissionData, this.pCOUNT, child.childCode);
    //     });
    //   }
    // });

    totalPreviousAdmissions2.forEach(child => {
      if (child.centreCode === centreCode) {
        child.admissionData.forEach((ad, i) => {
          this.checkPreviousAdmission2(i, ad, child.admissionData, this.pCOUNT2, child.childCode);
        });
      }
    });

    this.mAllChild.forEach(child => {
      child.admissionData.forEach((ad, index) => {
        if (index === 0) {
          if (child.dateOfAdmission.toDate() >= startDate && child.dateOfAdmission.toDate() <= endDate && ad.centreCode === centreCode) {
            firstAdmission++;
          }
        }

        if (index === 1) {
          if (ad.dateOfDischarge?.toDate()! >= startDate && ad.dateOfDischarge?.toDate()! <= endDate && ad.centreCode === centreCode) {
            firstDischarge++;
          }
        }

        if (index >= 2 && index % 2 === 0) {
          const d = ad.dateOfAdmission?.toDate()!;
          if (d > startDate && d < endDate && ad.centreCode === centreCode) {
            admissionCount++;
          }
        }

        if (index > 2 && index % 2 !== 0) {
          const d = ad.dateOfDischarge?.toDate()!;
          if (d > startDate && d < endDate && ad.centreCode === centreCode) {
            dischargeCount++;
          }
        }
      });
    });

    const mCurrenctCentreTotalUnits = currentCenter.totalUnits!
    const totalStayingStart = this.pCOUNT;
    const totalStayingEnd = this.pCOUNT2;
    currentCenter.occupiedUnits = totalStayingEnd;

    const report: any = {
      // centre: currentCenter,
      startDate:this.startDate1,
      endDate:this.endDate1,
      centreName: centreName,
      week:this.getWeek(this.startDate1),
      weekId : this.getWeekId(this.startDate1),
      year:this.getYear(this.startDate1),
      centreCode: centreCode,
      totalRooms: mCurrenctCentreTotalUnits,
      occupied: totalStayingEnd,
      Occupancy: +this.getPercentage(currentCenter),
    };

    this.mWeekly.push(report);
    this.uploadData(this.mWeekly)
  }
  checkPreviousAdmissionNew(i: number, ad: AdmissionType, data: AdmissionType[], prevcount: number, childCode: string) {


    try {
      if (i % 2 == 0) {
        // Admission type  if child is only admitted but not discharged before concerning date
        if (data[i + 1] != null && (data[i].dateOfAdmission!.toDate() <= this.startDate1) && data[i + 1].dateOfDischarge!.toDate() > this.startDate1) {
          this.pCOUNT++
          this.pList.push(childCode + ' - ' + data[length - 1] + `(${i})`)
        }
        // Admission type  if child is only admitted but not discharged before concerning date
        if (data[i + 1] == null && (data[i].dateOfAdmission!.toDate() <= this.startDate1)) {
          this.pCOUNT++
          this.pList.push(childCode + ' - ' + data[length - 1] + `(${i})`)

        }

        console.log('prevCount', this.pCOUNT)  // ? This is the total present child count

      }
    } catch (e) {
      console.error(childCode + `=${i}=>`, e)
    }
  }


  checkPreviousAdmission2(i: number, ad: AdmissionType, data: AdmissionType[], prevcount: number, childCode: string) {

    try {
      if (i % 2 == 0) {
        // Admission type  if child is only admitted but not discharged before concerning date
        if (data[i + 1] != null && (data[i].dateOfAdmission!.toDate() <= this.endDate1) && data[i + 1].dateOfDischarge!.toDate() >= this.endDate1) {
          this.pCOUNT2++
          this.pList2.push(childCode + ' - ' + data[length - 1] + `(${i})`)
        }
        // Admission type  if child is only admitted but not discharged before concerning date
        if (data[i + 1] == null && (data[i].dateOfAdmission!.toDate() <= this.endDate1)) {
          this.pCOUNT2++
          this.pList2.push(childCode + ' - ' + data[length - 1] + `(${i})`)

        }

        // console.log('prevCount', this.pCOUNT2)  // ? This is the total present child count

      }
    } catch (e) {
      console.error(childCode + `=${i}=>`, e)
    }
  }
  getPercentage(element: Centre) {
    if (element.totalUnits != null && element.occupiedUnits != null) {
      let total = element.totalUnits
      let available = element.occupiedUnits
      let percentage = ((available / total) * 100)
      return percentage.toFixed(2)
    }
    return ''
  }

  private uploadData(mWeekly: any[]) {
    mWeekly.forEach(it=>{
      let id = it.weekId
      this.mFirestore.collection(this.env.centreRankings).doc(it.centreCode).set(
          {
            [`rankings`]:{
              [id]:it
            }
          },{merge  :true})

    })

  }

  private getWeekId(startDate1: Date) {
    let w  = this.mDatePipe.transform(startDate1,'w')
    let year  = this.mDatePipe.transform(startDate1,'yyyy')

    return  year+'-'+w
  }
  private getWeek(startDate1: Date) {
    let w  = this.mDatePipe.transform(startDate1,'w')
    // let year  = this.mDatePipe.transform(startDate1,'yyyy')

    return  w
  }
  private getYear(startDate1: Date) {
    // let w  = this.mDatePipe.transform(startDate1,'w')
    let year  = this.mDatePipe.transform(startDate1,'yyyy')

    return  year
  }
}
